import React from "react";
import { Button } from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import DepartmentForm from "./DepartmentForm";
import useDepartment from "../../useDepartment";

interface ModalDepartmentFormProps {
  isOpen: boolean;
  setClose: (modalState: boolean) => void;
  value: unknown;
  useCustomHook: ReturnType<typeof useDepartment>
}

const ModalDepartmentForm = ({
  isOpen, setClose, value, useCustomHook,
}: ModalDepartmentFormProps) => {
  const { methods, handlePost, editValues } = useCustomHook;
  return (
    <Modal
      isOpen={isOpen}
      setOpen={setClose}
      title={`${editValues ? "Edit data" : "Tambah data"} - master departemen`}
      body={
        <DepartmentForm
          defaultValue={editValues}
          onClose={() => setClose(false)}
          useCustomHook={useCustomHook}
        />
      }
      footer={
        <div className="action-container">
          <Button
            variant="text"
            type="button"
            onClick={() => setClose(false)}
          >
            Batal
          </Button>
          <Button onClick={methods.handleSubmit(handlePost)}>
            Simpan
          </Button>
        </div>
      }
    />
  );
};

export default ModalDepartmentForm;
